// Header scroll class
$(window).scroll(function() {
  var sticky = $('.header-wrapper'),
    scroll = $(window).scrollTop();
  if (scroll >= 50) sticky.addClass('added_class');
  else sticky.removeClass('added_class');
});

$(document).ready(function() {

  // Initialize product image slider
  $('.product-slider').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    adaptiveHeight: true
  });

  // Set product info max-height on desktop to match viewport
  if ($(window).width() > 992) {
    var height = $(window).height();
    $('.custom_product_section.product__info-wrapper').attr('style', 'max-height:' + height + 'px; overflow:scroll;');
    window.addEventListener('resize', function() {
      height = $(window).height();
      $('.custom_product_section.product__info-wrapper').attr('style', 'max-height:' + height + 'px; overflow:scroll;');
    });
  }

  // Mobile: fix price bar on scroll
  checkScroll();
  $(window).scroll(function() {
    checkScroll();
  });

  function checkScroll() {
    if ($(window).width() < 992) {
      if ($(window).scrollTop() > 0) {
        $('.mobile_price').addClass('price_fixed');
      } else {
        $('.mobile_price').removeClass('price_fixed');
      }
    }
  }

  // Animated progress-bar slider dots
  setTimeout(function() {
    const $sliderDots = $('.slick-dots');
    if (!$sliderDots.length) return;

    const SLIDE_DURATION = 3000;
    const DOT_SIZE = 8;
    const BAR_WIDTH = 40;
    const DOT_GAP = 0;

    let currentSlide = 0;
    let animationFrame;
    let startTime;
    let isPaused = false;
    let totalSlides = 0;

    $sliderDots.css({
      'display': 'flex',
      'align-items': 'center',
      'justify-content': 'center',
      'padding': '5px 0'
    });

    function initializeDots() {
      const $dots = $sliderDots.find('li');
      totalSlides = $dots.length;

      $dots.each(function(index) {
        const $dot = $(this);
        const $button = $dot.find('button');
        const isActive = $dot.hasClass('slick-active');
        const buttonText = $button.text();

        $dot.css({
          'list-style': 'none',
          'margin': '0',
          'padding': '0',
          'flex-shrink': '0',
          'margin-right': index === $dots.length - 1 ? '0' : `${DOT_GAP}px`,
          'transition': 'margin-right 0.3s ease'
        });

        $button.html(`
          <span class="sr-only">${buttonText}</span>
          <span class="progress-container" style="
            position: relative;
            display: block;
            height: ${DOT_SIZE}px;
            overflow: hidden;
            border-radius: ${DOT_SIZE}px;
            background-color: rgba(200, 200, 200, 0.4);
            width: ${isActive ? BAR_WIDTH : DOT_SIZE}px;
            transition: width 0.3s ease;
          ">
            <span class="progress-fill" style="
              position: absolute;
              top: 0;
              left: 0;
              display: block;
              height: 100%;
              width: 100%;
              border-radius: ${DOT_SIZE}px;
              background-color: rgb(100, 100, 100);
              transform: scaleX(0);
              transform-origin: left center;
            "></span>
          </span>
        `);

        $button.css({
          'padding': '0',
          'margin': '0',
          'border': 'none',
          'background': 'transparent',
          'cursor': 'pointer',
          'display': 'block'
        });
      });
    }

    function animateProgress(timestamp) {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / SLIDE_DURATION, 1);

      const $activeDot = $sliderDots.find('li').eq(currentSlide);
      const $progressFill = $activeDot.find('.progress-fill');
      $progressFill.css('transform', `scaleX(${progress})`);

      if (progress >= 1) {
          if (currentSlide < totalSlides - 1) {
              $('.product-slider').slick('slickGoTo', currentSlide + 1);
              startTime = timestamp;
              animationFrame = requestAnimationFrame(animateProgress);
          }
          return;
      }

      animationFrame = requestAnimationFrame(animateProgress);
    }

    function updateActiveState(newIndex) {
      const $dots = $sliderDots.find('li');
      const extraMargin = BAR_WIDTH - DOT_SIZE;

      $dots.each(function(index) {
        const $dot = $(this);
        const $container = $dot.find('.progress-container');
        const $progressFill = $dot.find('.progress-fill');

        if (index === $dots.length - 1) {
          $dot.css('margin-right', '0');
        } else if (index === newIndex) {
          $dot.css('margin-right', `${DOT_GAP + extraMargin}px`);
        } else {
          $dot.css('margin-right', `${DOT_GAP}px`);
        }

        if (index === newIndex) {
          $container.css('width', `${BAR_WIDTH}px`);
          $progressFill.css('transform', 'scaleX(0)');
        } else if (index < newIndex) {
          $container.css('width', `${DOT_SIZE}px`);
          $progressFill.css('transform', 'scaleX(1)');
        } else {
          $container.css('width', `${DOT_SIZE}px`);
          $progressFill.css('transform', 'scaleX(0)');
        }
      });

      currentSlide = newIndex;
      startTime = null;

      if (currentSlide < totalSlides - 1 && !isPaused) {
        cancelAnimationFrame(animationFrame);
        animationFrame = requestAnimationFrame(animateProgress);
      }
    }

    const $slider = $('.slick-slider');
    if ($slider.length) {
      $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        updateActiveState(nextSlide);
      });
    }

    $sliderDots.on('click', 'button', function() {
      const $clickedLi = $(this).closest('li');
      const $allLis = $sliderDots.find('li');
      const clickedIndex = $allLis.index($clickedLi);
      if (clickedIndex !== -1 && clickedIndex !== currentSlide) {
        updateActiveState(clickedIndex);
      }
    });

    $sliderDots.on('mouseenter', function() {
      isPaused = true;
      cancelAnimationFrame(animationFrame);
    });

    $sliderDots.on('mouseleave', function() {
      isPaused = false;
      if (currentSlide < totalSlides - 1) {
        startTime = null;
        animationFrame = requestAnimationFrame(animateProgress);
      }
    });

    initializeDots();
    updateActiveState(0);

    if (totalSlides > 1) {
      animationFrame = requestAnimationFrame(animateProgress);
    }

  }, 1000);
  $('.product-slider').on('afterChange', function(event, slick, currentIndex) {
    if (currentIndex === slick.slideCount - 1) {
        $('#doppleContainer').fadeIn(300);
    } else {
        $('#doppleContainer').stop(true).fadeOut(200);
    }
  });
  (async function() {
      const doppleVisual = document.querySelector('atlatl-visual');
      const doppleProduct = document.querySelector('av-product');
      await doppleVisual.ready();
      doppleProduct.product.setValue('4DArms', true);
      doppleProduct.product.setValue('base', 'fiveSpoke');
  })();

  // ─── July 4th Countdown ─────────────────────────────────────────────────────
  function initJuly4Countdown() {
      const deadline = new Date('July 7, 2026 00:00:00').getTime();
      const second = 1000;
      const minute = second * 60;
      const hour = minute * 60;
      const day = hour * 24;

      const x = setInterval(function() {
          const distance = deadline - new Date().getTime();

          if (distance < 0) {
              clearInterval(x);
              const el = document.getElementById('july4-countdown');
              if (el) el.style.display = 'none';
              return;
          }

          const d = String(Math.floor(distance / day)).padStart(2, '0');
          const h = String(Math.floor((distance % day) / hour)).padStart(2, '0');
          const m = String(Math.floor((distance % hour) / minute)).padStart(2, '0');
          const s = String(Math.floor((distance % minute) / second)).padStart(2, '0');

          const dEl = document.getElementById('blk-days');
          const hEl = document.getElementById('blk-hours');
          const mEl = document.getElementById('blk-minutes');
          const sEl = document.getElementById('blk-seconds');

          if (dEl) dEl.innerText = d;
          if (hEl) hEl.innerText = h;
          if (mEl) mEl.innerText = m;
          if (sEl) sEl.innerText = s;
      }, 1000);
  }

  initJuly4Countdown();

});